
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import ModalFullScreen from '@/components/modal/ModalFullScreenNew.vue';
import UIButton from '@/components/button/ui-button.vue';
import { watch } from 'fs/promises';

@Component({
	components: {
		ModalFullScreen,
		UIButton,
	},
})
export default class ProjectModal extends Vue {
	watch() {}
	// this.$confirm({
	//   title: `Do you really want to complete the project?`,
	//   message: `All tasks will be closed if you complete this project`,
	//   button: {
	//     no: "No",
	//     yes: "Yes",
	//   },
	//   callback: async (confirm: any) => {
	//     if (confirm) {
	//       this.$emit("updateProjectStatus", { completed: true, active: false });
	//       this.statusProcessing = true;
	//     }
	//   },
	// });

	completeProject() {
		this.$emit('updateProjectStatus', { completed: true, active: false });
	}

	closeModal(): void {
		this.$emit('close');
	}
}
